var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "forecast-wrap" }, [
    _c(
      "div",
      {
        staticClass: "forecast-wrap-title",
        staticStyle: { "border-bottom": "1px solid rgba(0, 0, 0, 0.08)" },
      },
      [
        _c("card-title", {
          attrs: { title: _vm.title, "is-more": _vm.isMore },
          on: { onClickMainTitleMore: _vm.onClickMainTitleMore },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "forecast-wrap-content" }, [
      _vm.predict
        ? _c(
            "div",
            { on: { click: _vm.handleGoRoad } },
            [
              _c("card-sub-title", {
                attrs: {
                  title: _vm.congestedRoad,
                  "is-sub-more": _vm.isSubMore,
                },
              }),
              _vm._v(" "),
              _c("ul", { staticClass: "forecast-info" }, [
                _vm.morningLevel || _vm.predict.morningCongestRoad
                  ? _c("li", { staticClass: "forecast-info-tomorrow" }, [
                      _vm._v("\n          · 预计\n          "),
                      _vm.morningLevel
                        ? _c("div", [
                            _vm._v("\n            明日早高峰（7点-9点）辖区内"),
                            _c("span", { style: { color: _vm.morningState } }, [
                              _vm._v(_vm._s(_vm.morningLevel)),
                            ]),
                            _vm._v("，\n          "),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.predict.morningCongestRoad
                        ? _c("div", [
                            _vm._v("\n            最堵道路为"),
                            _c("span", [
                              _vm._v(_vm._s(_vm.predict.morningCongestRoad)),
                            ]),
                            _vm._v("。\n          "),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.eveningLevel || _vm.predict.eveningCongestRoad
                  ? _c("li", { staticClass: "forecast-info-tomorrow" }, [
                      _vm._v("\n          · 预计\n          "),
                      _vm.eveningLevel
                        ? _c("div", [
                            _vm._v("\n            晚高峰（17点-19点）辖区内"),
                            _c("span", { style: { color: _vm.eveningState } }, [
                              _vm._v(_vm._s(_vm.eveningLevel)),
                            ]),
                            _vm._v("，\n          "),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.predict.eveningCongestRoad
                        ? _c("div", [
                            _vm._v("\n            最堵道路为"),
                            _c("span", [
                              _vm._v(_vm._s(_vm.predict.eveningCongestRoad)),
                            ]),
                            _vm._v("。\n          "),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.morningCongestDay || _vm.eveningCongestDay
                  ? _c(
                      "li",
                      {
                        staticClass: "forecast-info-week",
                        class: { noPadding: !_vm.hotPlaces },
                      },
                      [
                        _vm._v("\n          · 未来7天\n          "),
                        _vm.morningCongestDay
                          ? _c("div", [
                              _c("span", { staticClass: "wall" }, [
                                _vm._v(_vm._s(_vm.morningCongestDay)),
                              ]),
                              _vm._v("早高峰最堵，\n          "),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.eveningCongestDay
                          ? _c("div", [
                              _c("span", { staticClass: "wall" }, [
                                _vm._v(_vm._s(_vm.eveningCongestDay)),
                              ]),
                              _vm._v("晚高峰最堵，建议关注\n          "),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.predict && _vm.hotPlaces
        ? _c("div", {
            staticClass: "forecast-wrap-divider",
            staticStyle: { "border-top": "1px solid rgba(0, 0, 0, 0.08)" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hotPlaces
        ? _c(
            "div",
            { on: { click: _vm.handleGoDestination } },
            [
              _c("card-sub-title", {
                attrs: {
                  title: _vm.popularDestinations,
                  "is-sub-more": _vm.isSubMore,
                },
              }),
              _vm._v(" "),
              _c("ul", { staticClass: "forecast-info" }, [
                _vm.hotPlaces.sceneName
                  ? _c("li", { staticClass: "forecast-info-tomorrow" }, [
                      _vm._v("\n          · 最热门景区是"),
                      _c("span", { staticClass: "hot-color" }, [
                        _vm._v(_vm._s(_vm.hotPlaces.sceneName)),
                      ]),
                      _vm._v("，热度持续"),
                      _c("span", { style: { color: _vm.scenicColor } }, [
                        _vm._v(_vm._s(_vm.hotPlaces.sceneTendency)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hotPlaces.trafficPointName
                  ? _c("li", { staticClass: "forecast-info-tomorrow" }, [
                      _vm._v("\n          · 最热门交通枢纽是"),
                      _c("span", { staticClass: "hot-color" }, [
                        _vm._v(_vm._s(_vm.hotPlaces.trafficPointName)),
                      ]),
                      _vm._v("，热度持续"),
                      _c("span", { style: { color: _vm.hubColor } }, [
                        _vm._v(_vm._s(_vm.hotPlaces.trafficPointTendency)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hotPlaces.businessName
                  ? _c("li", { staticClass: "forecast-info-week noPadding" }, [
                      _vm._v("\n          · 最热门商圈是"),
                      _c("span", { staticClass: "hot-color" }, [
                        _vm._v(_vm._s(_vm.hotPlaces.businessName)),
                      ]),
                      _vm._v("，热度持续"),
                      _c("span", { style: { color: _vm.businessColor } }, [
                        _vm._v(_vm._s(_vm.hotPlaces.businessTendency)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }